import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className='privacy-policy-page'>
      <nav className="container shadow-none py-0">
        <div className="navbar navbar-expand-lg landing-navbar border-top-0">
          <div className="navbar-brand app-brand demo d-flex py-0 py-lg-2 me-6">
            <a className="app-brand-link">
              <img src="/assets/img/logo-2.png" alt="" style={{ width: '60px' }} />
              <span className="app-brand-text demo fw-semibold ms-2 ps-1" style={{ color: '#efbb30' }}>
                THIEN LONG GROUP
              </span>
            </a>
          </div>

          <div className="landing-menu-overlay d-lg-none"></div>
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li>
              <a
                className="btn btn-text-warning px-2 px-sm-4 px-lg-2 px-xl-4"
                onClick={() => {
                  navigate('/login');
                }}
              >
                <span className="tf-icons ri-user-line me-md-1"></span>
                <span className="d-none d-md-block">Đăng nhập</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <section className="section-py privacy-policy">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <div className="text-center privacy-policy-title">Chính Sách Bảo Mật</div>
              <div className="">
                <h4 className="mb-2">Giới Thiệu</h4>
                <p>Chúng tôi cam kết bảo vệ quyền riêng tư của bạn. Chính sách Bảo mật này giải thích cách chúng tôi thu thập, sử dụng, và bảo vệ thông tin cá nhân của bạn khi bạn sử dụng ứng dụng web vận chuyển của chúng tôi.</p>
              </div>
              <div>
                <h4 className="mb-2">Thông Tin Chúng Tôi Thu Thập</h4>
                <div>Chúng tôi có thể thu thập các loại thông tin sau:</div>
                <ul>
                  <li>Thông tin cá nhân: Tên, địa chỉ email, số điện thoại, và địa chỉ giao hàng.</li>
                  <li>Thông tin giao dịch: Chi tiết về các giao dịch bạn thực hiện qua ứng dụng.</li>
                  <li>Thông tin kỹ thuật: Địa chỉ IP, loại trình duyệt, và thông tin về thiết bị của bạn.</li>
                </ul>
              </div>
              <div>
                <h4 className="mb-2">Cách Chúng Tôi Sử Dụng Thông Tin</h4>
                <div>Chúng tôi sử dụng thông tin của bạn cho các mục đích sau:</div>
                <ul>
                  <li>Để cung cấp dịch vụ vận chuyển.</li>
                  <li>Để xử lý thanh toán và quản lý đơn hàng.</li>
                  <li>Để liên hệ với bạn về các cập nhật, thông báo và khuyến mãi.</li>
                  <li>Để cải thiện trải nghiệm người dùng và phát triển dịch vụ.</li>
                </ul>
              </div>
              <div>
                <h4 className="mb-2">Bảo Mật Thông Tin</h4>
                <p>
                  Chúng tôi áp dụng các biện pháp bảo mật hợp lý để bảo vệ thông tin cá nhân của bạn khỏi việc truy cập trái phép, sử dụng sai mục đích hoặc tiết lộ. Tuy nhiên, không có phương thức truyền tải qua Internet hoặc phương thức lưu trữ
                  điện tử nào là hoàn toàn an toàn.
                </p>
              </div>
              <div>
                <h4 className="mb-2">Chia Sẻ Thông Tin</h4>
                <p>Chúng tôi không bán, cho thuê hoặc cho phép bên thứ ba sử dụng thông tin cá nhân của bạn.</p>
              </div>
              <div>
                <h4 className="mb-2">Quyền Của Bạn</h4>
                <p>Bạn có quyền yêu cầu truy cập, chỉnh sửa hoặc xóa thông tin cá nhân của mình. Bạn cũng có thể từ chối nhận thông tin tiếp thị từ chúng tôi.</p>
              </div>
              <div>
                <h4 className="mb-2">Thay Đổi Chính Sách</h4>
                <p>Chúng tôi có thể cập nhật Chính sách Bảo mật này theo thời gian. Mọi thay đổi sẽ được thông báo trên trang web của chúng tôi. Bạn nên kiểm tra định kỳ để nắm bắt thông tin mới nhất.</p>
              </div>
              <div>
                <h4 className="mb-2">Liên Hệ</h4>
                <p>Nếu bạn có bất kỳ câu hỏi nào về Chính sách Bảo mật này, vui lòng liên hệ với chúng tôi qua địa chỉ email: contact@vanchuyenthienlong.com.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-top position-relative overflow-hidden">
          <img src="/assets/img/landing-page/footer-bg.png" alt="footer bg" className="footer-bg banner-bg-img" />
          <div className="container position-relative">
            <div className="row gx-0 gy-7 gx-sm-6 gx-lg-12">
              <div className="col-lg-9">
                <a className="app-brand-link mb-6">
                  <img src="/assets/img/logo-2.png" alt="logo" style={{ width: '60px' }} />
                  <span className="app-brand-text demo footer-link fw-semibold ms-1" style={{ color: '#efbb30' }}>
                    THIEN LONG GROUP
                  </span>
                </a>
                <p className="footer-text footer-logo-description mb-6">Nếu bạn có bất kỳ câu hỏi nào về Chính sách Bảo mật này, vui lòng liên hệ với chúng tôi qua địa chỉ email: contact@vanchuyenthienlong.com.</p>
              </div>
              <div className="col-lg-3 col-md-4">
                <h6 className="footer-title mb-4 mb-lg-6">Tải xuống ứng dụng của chúng tôi</h6>
                <a className="d-block footer-link mb-4">
                  <img src="/assets/img/landing-page/apple-icon.png" alt="apple icon" />
                </a>
                <a className="d-block footer-link">
                  <img src="/assets/img/landing-page/google-play-icon.png" alt="google play icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
